import React from "react";
import {Col, Row} from "antd";
import {StyledContactContainer, StyledSection7Container} from "./Section7.styles";
import {
    MailIcon, PhoneIcon,
    Section7Icon,
} from "../../../../assets";
import {MyButton} from "../../../common/MyButton/MyButton";
import {Link} from "react-router-dom";


export const Section7 = ({setIsModalOpen}) => {


    return (
        <StyledSection7Container>
            <Col xs= {{
                pull: 1,
                span: 22,
                push: 1,
            }}lg={{
                pull: 3,
                span: 18,
                push: 3,
            }} xl={{
                pull: 4,
                span: 16,
                push: 4,
            }}>
                <Row align="middle" justify={{xs: "center", sm: "center", md: "center", lg: "start"}} className="container7">
                    <Col xs={24} md={4}><Section7Icon/></Col>
                    <Col xs={24} md={20}>
                        <Col className="section7Container">
                            <span className="section7Text">
                                Give us a call, send email request, or submit the form. <br /> We can help you!
                            </span>
                        </Col>
                        <Col>
                            <Row align="middle" className="buttonsContainer">
                                <Link to="mailto:service@axisrepair.com">
                                    <StyledContactContainer justify={{xs: "center", xl: "space-between"}}
                                                            align="middle">
                                        <MailIcon/>
                                        <span>service@axisrepair.com</span>
                                    </StyledContactContainer>
                                </Link>
                                <Link to="tel:(760) 439-7522">
                                    <StyledContactContainer className="phoneContainer"
                                                            justify={{xs: "center", xl: "space-between"}}
                                                            align="middle">
                                        <PhoneIcon/>
                                        <span>(760) 439-7522</span>
                                    </StyledContactContainer>
                                </Link>
                                <MyButton type="primary" onClick={() => setIsModalOpen(true)}>Schedule
                                    Appointment</MyButton>
                            </Row>
                        </Col>
                    </Col>
                </Row>
            </Col>
        </StyledSection7Container>
    )
}